// Первое касание устройства: метка из ссылки (utm, ref, qr, партнёр, игра) запоминается один раз
// и уходит на сервер при создании профиля (гость, вход). До регистрации события пишутся с anon_id.
import { sourceFromQuery, sourceFromStartParam, hasSource, type Source } from '@shared/source.ts';
import { store } from './storage.ts';
import { tgStartParam } from './telegram.ts';

const K_ANON = 'mk_anon', K_SRC = 'mk_src', K_SEEN = 'mk_first_seen';

export function anonId() {
  let id = store.get(K_ANON);
  if (!id) {
    id = Array.from(crypto.getRandomValues(new Uint8Array(12)), b => b.toString(16).padStart(2, '0')).join('');
    store.set(K_ANON, id);
  }
  return id;
}

// вызывается один раз при старте: возвращает метку этого визита (для события visit), если она есть
export function captureSource(): Source | null {
  const fromUrl = sourceFromQuery(location.search);
  const sp = tgStartParam() ?? new URLSearchParams(location.search).get('startapp');
  const s = hasSource(fromUrl) ? fromUrl : sourceFromStartParam(sp);
  if (!store.get(K_SEEN)) store.set(K_SEEN, String(Date.now()));
  if (hasSource(s) && !store.get(K_SRC)) store.set(K_SRC, JSON.stringify(s));
  return hasSource(s) ? s : null;
}

export function firstTouch() {
  let s: Partial<Source> = { kind: 'organic' };
  try { s = JSON.parse(store.get(K_SRC) ?? 'null') ?? s; } catch { /* — */ }
  return { ...s, anon_id: anonId(), first_seen: Number(store.get(K_SEEN)) || Date.now() };
}
